import React from 'react';
import { BookOpen, CheckCircle2, Clock } from 'lucide-react';

interface LearningModuleProps {
  title: string;
  description: string;
  progress: number;
  duration: string;
  isCompleted: boolean;
  onClick: () => void;
}

export default function LearningModule({
  title,
  description,
  progress,
  duration,
  isCompleted,
  onClick
}: LearningModuleProps) {
  return (
    <div 
      onClick={onClick}
      className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow p-6 cursor-pointer border border-gray-100"
    >
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center">
          <BookOpen className="w-6 h-6 text-indigo-600 mr-3" />
          <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
        </div>
        {isCompleted && (
          <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0" />
        )}
      </div>
      
      <p className="text-gray-600 mb-4 line-clamp-2">{description}</p>
      
      <div className="flex items-center justify-between text-sm">
        <div className="flex items-center text-gray-500">
          <Clock className="w-4 h-4 mr-1" />
          <span>{duration}</span>
        </div>
        
        <div className="flex items-center">
          <div className="bg-gray-200 h-2 w-24 rounded-full overflow-hidden">
            <div 
              className="bg-indigo-600 h-full rounded-full"
              style={{ width: `${progress}%` }}
            />
          </div>
          <span className="ml-2 text-gray-600">{progress}%</span>
        </div>
      </div>
    </div>
  );
}